module.exports = __webpack_public_path__ + "img/l_ct.8bcfa708.png";